import ApiServer from "../ApiServer.js";
import * as amplify from "./amplify.ts";

var subscribe,unsubscribe,isActive = !!window.WebSocket,noop = function(){};


if(isActive){
  var ws = null,handlers={},init;
  
  function connectionneeded(){
    var size = 0;
    for(var i in handlers){
      var arrayOfHandler = handlers[i];
      size += arrayOfHandler.length;
    }
    return size>0;
  }
  
  function handleWebSocketNotif(json){
    var msg = new ApiServer.types.WebSocketPushMessage(json);
    if(msg.type==='sessionExpired'){
      //reset handlers
      handlers={};
      amplify.publish("sessionExpired",{fromWebsocket:true});
      ws=null;
    }else if(msg.type==="sessionClosed"){
      //maybe do something here it is when user manually logout
      ws=null;
    }else if(msg.type==="websocketExpired"){
      //maybe do something here it is when user manually logout
      ws=null;
    }else if(msg.type==='push'){
      var handlerOfType = handlers[msg.push.messageType];
      if(handlerOfType){
        handlerOfType.forEach(function(handler){
          handler(msg);
        });
      }
      if(handlers.AllPush){
        handlers.AllPush.forEach(function(handler){
          handler(msg);
        });
      }
    }
  }
  window.emulateNotification = handleWebSocketNotif;
  init = function(){
    if(!connectionneeded()||ws!==null){
      return;
    }
    //create a temp fake websocket to avoid it to be null and init would create a new one
    ws = {send:noop};
    ApiServer.webgetWebSocketUrl(function(uri){
      ws = new WebSocket(uri);
      ws.onmessage = function(evt){
        handleWebSocketNotif(JSON.parse(evt.data));
      };
      ws.onclose = function(evt){
        ws = null;
        //list of code : https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent#Status_codes
        switch(evt.code){
          //normal close case, we try to reopen
          case 1000:
          case 1001:{
            setTimeout(init, 1000);
            break;
          }
          //abnormal close case happens when we restart server
          case 1006:{
            setTimeout(init, 30000);
            break;
          }
          default:{
            init = function(){};
            ApiServer.webjslog("websocket close error "+evt.code + " " +evt.reason);
          }
        }
      };
      ws.onerror = function(evt){
        //it happen when ssl certificate is not good
        if(evt.code===undefined){
          ApiServer.webjslog("websocket error Cannot open! check ssl certificate");
        }else{
          ApiServer.webjslog("websocket error "+evt.code + " " +evt.reason);
        }
        init = function(){};
        ws.close();
      };
        
    },function(){
      //error handling we disable everything
      console.log("webgetwebsocket error")
      init = function(){};
    });
    
  };
  //ping every minute
  setInterval(function(){
    if(ws!==null && ws.readyState===1){
      ws.send("ping");  
    }
  },50000); //50s because it looks like being closed after 60s
  
  subscribe = function (pushTypes, handler){
    pushTypes = (typeof pushTypes==='string')?[pushTypes]:pushTypes;
    for(var i=0;i<pushTypes.length;i++){
      var 
        pushType = pushTypes[i],
        hanlerArray = handlers[pushType];
      if(!hanlerArray){
        hanlerArray = handlers[pushType] = [];
      }
      hanlerArray.push(handler);
    } 
    setTimeout(init, 1000);
  }
  unsubscribe = function(pushTypes, handler){
    pushTypes = (typeof pushTypes==='string')?[pushTypes]:pushTypes;
    for(var i=0;i<pushTypes.length;i++){
      var 
        pushType = pushTypes[i],
        handlerArray = handlers[pushType];
      if(handlerArray){
        var index = handlerArray.indexOf(handler);
        if(index>-1){
          handlerArray.splice(index, 1);
        }
      }
    }
  }
}else{
  subscribe = unsubscribe = noop;
}
export {
  subscribe,
  unsubscribe,
  isActive
};